module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon1.924ce8fb.png";